import { useState } from "react";
import axios from "axios";
import { Loader2, CheckCircle2 } from "lucide-react";
import { Input } from "@/components/ui/input";

const API = process.env.REACT_APP_BACKEND_URL;

export const SmartlinkLeadForm = ({ slug, labels }) => {
  const [form, setForm] = useState({ name: "", email: "" });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) {
      setError(labels.formError);
      return;
    }
    setError("");
    setSubmitting(true);
    try {
      await axios.post(`${API}/api/smartlinks/${slug}/leads`, form);
      setSubmitted(true);
    } catch {
      setError(labels.formError);
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div data-testid="smartlink-lead-success" className="flex items-center gap-2 text-white text-sm font-medium py-2">
        <CheckCircle2 className="w-5 h-5 text-brand-blue shrink-0" /> {labels.formSuccess}
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} data-testid="smartlink-lead-form" className="flex flex-col gap-2.5">
      <Input
        data-testid="smartlink-lead-name-input"
        value={form.name}
        onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
        placeholder={labels.namePlaceholder}
        className="bg-white/10 border-white/15 text-white placeholder:text-neutral-500 h-11"
      />
      <Input
        data-testid="smartlink-lead-email-input"
        type="email"
        value={form.email}
        onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
        placeholder={labels.emailPlaceholder}
        className="bg-white/10 border-white/15 text-white placeholder:text-neutral-500 h-11"
      />
      {error && <p className="text-brand-red text-xs" data-testid="smartlink-lead-error">{error}</p>}
      <button
        type="submit"
        disabled={submitting}
        data-testid="smartlink-lead-submit-button"
        className="h-11 rounded-full bg-white text-black text-sm font-bold hover:bg-neutral-200 transition-colors duration-300 flex items-center justify-center gap-2 disabled:opacity-60"
      >
        {submitting && <Loader2 className="w-4 h-4 animate-spin" />} {labels.formSubmit}
      </button>
      <p data-testid="smartlink-lead-privacy-note" className="text-[11px] text-neutral-500 text-center leading-relaxed">
        {labels.privacyNote}
      </p>
    </form>
  );
};
